/* =========================================================
RXWEAR – GPX → SVG (Trace / Dénivelé) + Map routes-only (OSM Overpass)
✅ 2 modes : Tracé GPS / Profil dénivelé
✅ Texte éditable + 4 métriques ON/OFF
✅ Sliders + options (outline/glow/flipY/caps)
✅ Fond carte VECTORIEL (routes) autour du tracé (DTF-safe) ON/OFF
✅ Routes filtrées + corridor autour du tracé + simplification (léger)
========================================================= */

(() => {
  const EXAMPLE_GPX_URL = "https://cdn.shopify.com/s/files/1/0293/1513/7635/files/exemple-de-trace-gps.gpx?v=1768900540";
  const OVERPASS_ENDPOINT = "https://overpass-api.de/api/interpreter";

  const $ = (id) => document.getElementById(id);

  // -----------------------------
  // UI: regroupe les options avancées dans un toggle replié
  // (évite de surcharger le panneau)
  // -----------------------------
  function mountAdvancedToggle() {
    const root = $("rx-gpx-tool-root") || document;

    // IDs à mettre dans "Options avancées" (UI simplifiée)
    // ✅ inclut les options entourées sur ta capture
    const ADV_INPUT_IDS = [
      "rxStrokeWidth",      // Épaisseur
      "rxStrokeColor",      // Couleur
      "rxTraceScale",       // Taille du tracé / courbe
      "rxOutlineOn",        // Outline (bloc complet)
      "rxRoundCaps",        // Options (bouts arrondis)
      "rxGlowOn",           // Glow
      "rxTheme",            // Thème
      "rxPanelX",           // Placement summary
      "rxPanelY",
      "rxSummaryScale"      // Taille summary
    ];

    // Cherche la grille des contrôles (celle du panneau principal)
    const controlsGrid = root.querySelector(".rxcard .rxctrlgrid");
    if (!controlsGrid) return;

    // Évite de remonter 2 fois si Shopify re-render
    if (controlsGrid.querySelector(".rxadvancedwrap")) return;

    // Récupère les cartes (.rxctrl) à déplacer (1 seule carte par ID)
    const toMove = [];
    const seen = new Set();
    for (const id of ADV_INPUT_IDS) {
      const el = $(id);
      const ctrl = el?.closest?.('.rxctrl');
      if (ctrl && !seen.has(ctrl)) {
        seen.add(ctrl);
        toMove.push(ctrl);
      }
    }

    // Rien à déplacer -> pas de toggle
    if (!toMove.length) return;

    const wrap = document.createElement("div");
    wrap.className = "rxctrl rxspan12 rxadvancedwrap";

    const details = document.createElement("details");
    details.className = "rxdetails";
    details.open = false;

    const summary = document.createElement("summary");
    summary.className = "rxdetailssum";
    summary.innerHTML = `<span>Options avancées</span><span class="rxchev" aria-hidden="true">▾</span>`;
    details.appendChild(summary);

    const helper = document.createElement('div');
    helper.className = 'rxmini';
    helper.style.margin = '8px 0 10px';
    helper.textContent = "";

    const inner = document.createElement("div");
    inner.className = "rxctrlgrid rxadvancedgrid";

    // Déplace les blocs dans la grille avancée
    toMove.forEach((node) => inner.appendChild(node));

    details.appendChild(helper);
    details.appendChild(inner);
    wrap.appendChild(details);

    // Placement : juste après le bloc "Résumé" si présent, sinon après le bloc mode
    const anchor = $("rxPanelOn")?.closest?.('.rxctrl') || controlsGrid.querySelector('.rxctrl');
    if (anchor && anchor.parentElement === controlsGrid) {
      anchor.insertAdjacentElement('afterend', wrap);
    } else {
      controlsGrid.appendChild(wrap);
    }
  }

  // ----- Elements -----
  const overlay = $("rxDesignOverlay");
  const statusEl = $("rxStatus");

  const strokeWidth = $("rxStrokeWidth");
  const strokeWidthVal = $("rxStrokeWidthVal");
  const outlineWidth = $("rxOutlineWidth");
  const outlineWidthVal = $("rxOutlineWidthVal");
  const glowStrength = $("rxGlowStrength");
  const glowVal = $("rxGlowVal");
  const traceScale = $("rxTraceScale");
  const traceScaleVal = $("rxTraceScaleVal");
  const summaryScale = $("rxSummaryScale");
  const summaryScaleVal = $("rxSummaryScaleVal");
const mapLoader = $("rxMapLoader");
const mapLoaderTxt = $("rxMapLoaderTxt");
const mapOn = $("rxMapOn");

function setMapBusy(on){
  if (!mapLoader || !mapLoaderTxt) return;
  mapLoader.style.display = on ? "inline-block" : "none";
  mapLoaderTxt.style.display = on ? "inline" : "none";

  // optionnel : éviter double clic pendant fetch
  if (mapOn) mapOn.disabled = on;
}

  // Map controls (optional in DOM)
  const mapOnEl = $("rxMapOn");

  // ----- State -----
  let lastSvg = "";
  let lastObjectUrl = "";
  let lastPts = null;
  let glowManuallyChanged = false;

  // async control
  let buildSeq = 0;              // increments each rebuild
  let mapCache = new Map();      // bboxKey -> ways
  let mapGroupCache = new Map(); // renderKey -> svgGroup

  // -----------------------------
  // Utils
  // -----------------------------
  function setStatus(msg, err = false) {
    if (!statusEl) return;
    statusEl.textContent = msg;
    statusEl.style.color = err ? "#b00020" : "#444";
  }

  function clamp01(x) { return Math.max(0, Math.min(1, x)); }

  function escapeXml(s) {
    return String(s ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function parseIsoTime(s) {
    const t = Date.parse(s);
    return Number.isFinite(t) ? t : null;
  }

  function parseGpx(text) {
    const parser = new DOMParser();
    const xml = parser.parseFromString(text, "application/xml");
    if (xml.querySelector("parsererror")) throw new Error("GPX invalide (XML).");

    const trkpts = Array.from(xml.getElementsByTagName("trkpt"));
    if (trkpts.length < 2) throw new Error("Aucun <trkpt> trouvé. Ton GPX doit contenir une trace.");

    const pts = [];
    for (const p of trkpts) {
      const lat = parseFloat(p.getAttribute("lat"));
      const lon = parseFloat(p.getAttribute("lon"));
      if (!Number.isFinite(lat) || !Number.isFinite(lon)) continue;

      const eleNode = p.getElementsByTagName("ele")[0];
      const timeNode = p.getElementsByTagName("time")[0];

      const ele = eleNode ? parseFloat(eleNode.textContent) : null;
      const time = timeNode ? parseIsoTime(timeNode.textContent.trim()) : null;

      pts.push({ lat, lon, ele: Number.isFinite(ele) ? ele : null, time });
    }
    if (pts.length < 2) throw new Error("Pas assez de points GPS valides.");
    return pts;
  }

  function haversineMeters(lat1, lon1, lat2, lon2) {
    const R = 6371000;
    const toRad = (d) => d * Math.PI / 180;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) ** 2;
    return 2 * R * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function computeStats(pts, movingSpeedThresholdMps = 1.0) {
    let dist = 0, gain = 0;
    let hasTime = true;
    let firstTime = null, lastTime = null;
    let movingMs = 0;

    for (let i = 1; i < pts.length; i++) {
      const a = pts[i - 1], b = pts[i];
      const d = haversineMeters(a.lat, a.lon, b.lat, b.lon);
      dist += d;

      if (a.ele != null && b.ele != null) {
        const de = b.ele - a.ele;
        if (de > 0) gain += de;
      }

      if (a.time == null || b.time == null) {
        hasTime = false;
      } else {
        if (firstTime == null) firstTime = a.time;
        lastTime = b.time;
        const dt = b.time - a.time;

        if (dt > 0 && dt < 1000 * 60 * 10) {
          const speed = d / (dt / 1000);
          if (speed >= movingSpeedThresholdMps) movingMs += dt;
        }
      }
    }

    const elapsedMs = (hasTime && firstTime != null && lastTime != null) ? (lastTime - firstTime) : null;

    return {
      distanceM: dist,
      hasTime,
      elapsedMs,
      movingMs: hasTime ? movingMs : null,
      elevGainM: gain > 0 ? gain : null
    };
  }

  function buildDistanceElevation(pts) {
    let dist = 0;
    const distKm = [0];
    const eleM = [pts[0].ele];
    for (let i = 1; i < pts.length; i++) {
      const a = pts[i - 1], b = pts[i];
      dist += haversineMeters(a.lat, a.lon, b.lat, b.lon);
      distKm.push(dist / 1000);
      eleM.push(b.ele);
    }
    return { distKm, eleM };
  }

  function formatDuration(ms) {
    if (ms == null) return "—";
    const totalSec = Math.max(0, Math.floor(ms / 1000));
    const h = Math.floor(totalSec / 3600);
    const m = Math.floor((totalSec % 3600) / 60);
    const s = totalSec % 60;
    return h > 0 ? `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}` : `${m}:${String(s).padStart(2, "0")}`;
  }

  function formatPace(distanceM, ms) {
    if (ms == null || !Number.isFinite(distanceM) || distanceM <= 0) return "—";
    const secPerKm = (ms / 1000) / (distanceM / 1000);
    if (!Number.isFinite(secPerKm)) return "—";
    const m = Math.floor(secPerKm / 60);
    const s = Math.round(secPerKm % 60);
    return `${m}:${String(s).padStart(2, "0")}/KM`;
  }

  function iconPaths(kind, color) {
    const c = color;
    switch (kind) {
      case "pin":
        return `<path d="M12 22s7-6.2 7-12a7 7 0 10-14 0c0 5.8 7 12 7 12z" fill="${c}"/><circle cx="12" cy="10" r="2.6" fill="#111" opacity="0.35"/>`;
      case "clock":
        return `<circle cx="12" cy="12" r="9" fill="none" stroke="${c}" stroke-width="2.6"/><path d="M12 7v5l3.5 2" stroke="${c}" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/>`;
      case "flame":
        return `<path d="M12 2c2 4-1 5 1 8 1.2 2 4 2 4 6a5 5 0 11-10 0c0-2 1-3.2 2.2-4.4C10.8 10 10 8.2 12 2z" fill="${c}"/>`;
      case "mountain":
        return `<path d="M3 20l6-10 3 5 3-7 6 12H3z" fill="${c}"/>`;
      case "bolt":
        return `<path d="M13 2L4 14h6l-1 8 9-12h-6l1-8z" fill="${c}"/>`;
      case "trophy":
        return `<path d="M7 4h10v3c0 3-2.5 5-5 5s-5-2-5-5V4z" fill="${c}"/><path d="M9 12v3h6v-3" fill="${c}"/><path d="M8 18h8v2H8z" fill="${c}"/><path d="M5 6H3v2c0 2.2 1.6 4 4 4" stroke="${c}" stroke-width="2" fill="none"/><path d="M19 6h2v2c0 2.2-1.6 4-4 4" stroke="${c}" stroke-width="2" fill="none"/>`;
      default:
        return `<circle cx="12" cy="12" r="8" fill="${c}" opacity="0.9"/>`;
    }
  }

  function getMode() {
    return $("rxModeElev")?.checked ? "elev" : "trace";
  }

  // -----------------------------
  // UI Mode (3 icons) -> legacy inputs bridge
  // -----------------------------
  function setModeFromUI(val) {
    const modeTrace = $("rxModeTrace");
    const modeElev  = $("rxModeElev");
    const mapOn     = $("rxMapOn");

    if (val === "elev") {
      if (modeElev) modeElev.checked = true;
      if (modeTrace) modeTrace.checked = false;
      if (mapOn) mapOn.checked = false;
      requestRebuild();
      return;
    }

    // trace (plain / map)
    if (modeTrace) modeTrace.checked = true;
    if (modeElev) modeElev.checked = false;

    if (mapOn) mapOn.checked = (val === "trace_map");
    requestRebuild();
  }

  function getMetrics() {
    return [
      { on: $("rxM1On")?.checked, icon: $("rxM1Icon")?.value, value: $("rxM1Val")?.value, label: $("rxM1Lab")?.value },
      { on: $("rxM2On")?.checked, icon: $("rxM2Icon")?.value, value: $("rxM2Val")?.value, label: $("rxM2Lab")?.value },
      { on: $("rxM3On")?.checked, icon: $("rxM3Icon")?.value, value: $("rxM3Val")?.value, label: $("rxM3Lab")?.value },
      { on: $("rxM4On")?.checked, icon: $("rxM4Icon")?.value, value: $("rxM4Val")?.value, label: $("rxM4Lab")?.value },
    ];
  }

  function autofillMetrics(stats) {
    const distKm = stats.distanceM / 1000;
    if ($("rxM1Val")) $("rxM1Val").value = `${distKm.toFixed(distKm < 10 ? 2 : 1)} KM`;
    if ($("rxM2Val")) $("rxM2Val").value = stats.hasTime ? formatDuration(stats.elapsedMs) : "—";
    if ($("rxM3Val")) $("rxM3Val").value = stats.hasTime ? formatPace(stats.distanceM, (stats.movingMs || stats.elapsedMs)) : "—";
    if ($("rxM4Val")) $("rxM4Val").value = (stats.elevGainM != null) ? `${Math.round(stats.elevGainM)} M D+` : "—";

    if (!stats.hasTime && $("rxM2On")) $("rxM2On").checked = false;
    if (stats.elevGainM == null && $("rxM4On")) $("rxM4On").checked = false;
  }

  function buildDefs({ glowOn, glowColor, glowStrength, sw }) {
    if (!glowOn) return `<defs></defs>`;
    const gs = clamp01(Number(glowStrength ?? 0.7));
    const glowStd = (sw * 0.45) * gs;
    const glowOpacity = 0.90 * gs;
    return `
<defs>
  <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
    <feGaussianBlur stdDeviation="${glowStd.toFixed(2)}" result="blur"/>
    <feFlood flood-color="${glowColor}" flood-opacity="${glowOpacity.toFixed(2)}" result="color"/>
    <feComposite in="color" in2="blur" operator="in" result="coloredBlur"/>
    <feMerge>
      <feMergeNode in="coloredBlur"/>
      <feMergeNode in="SourceGraphic"/>
    </feMerge>
  </filter>
</defs>`.trim();
  }

  function buildPanel({
    size, panelOn, theme, topTitle, bottomTitle, metrics,
    panelX = 0.65, panelY = 0.50, summaryScale = 1.08
  }) {
    if (!panelOn) return "";

    const accent = (theme === "white") ? "#ffffff" : "#ff6a00";
    const textMain = "#ffffff";
    const textDim = "#ffffff";
    const textDimOpacity = 0.65;

    const safe = (s, n) => String(s || "").trim().slice(0, n);

    const titleY = Math.round(size * 0.09);
    const titleFs = Math.round(size * 0.07);
    const topTxt = safe(topTitle || "RUN SUMMARY", 60);

    const topTitleSvg = `
<text x="${Math.round(size * 0.5)}" y="${titleY}"
  fill="${accent}" font-size="${titleFs}" font-weight="900" letter-spacing="2"
  text-anchor="middle" dominant-baseline="middle"
  font-family="system-ui, -apple-system, Segoe UI, Roboto, Arial">
  ${escapeXml(topTxt)}
</text>`.trim();

    const iconSize = Math.round(size * 0.050 * summaryScale);
    const valueFs = Math.round(size * 0.044 * summaryScale);
    const labelFs = Math.round(size * 0.028 * summaryScale);
    const rowGap = Math.round(size * 0.075 * summaryScale);

    const bx = Math.round(size * panelX);
    const by = Math.round(size * panelY);

    const enabled = (metrics || []).filter(m => m && m.on !== false).slice(0, 4);

    const rows = enabled.map((m, i) => {
      const y = by + i * rowGap;
      const s = (iconSize / 24).toFixed(4);
      return `
<g transform="translate(${bx}, ${y})">
  <g transform="translate(0, ${-iconSize / 2}) scale(${s})">
    ${iconPaths(m.icon, accent)}
  </g>
  <text x="${iconSize + 14}" y="0"
    fill="${textMain}" font-size="${valueFs}" font-weight="900"
    dominant-baseline="middle"
    font-family="system-ui, -apple-system, Segoe UI, Roboto, Arial">
    ${escapeXml(m.value)}
  </text>
  <text x="${iconSize + 14}" y="${Math.round(labelFs * 1.4)}"
    fill="${textDim}" opacity="${textDimOpacity}"
    font-size="${labelFs}" font-weight="700" letter-spacing="1"
    font-family="system-ui, -apple-system, Segoe UI, Roboto, Arial">
    ${escapeXml(m.label)}
  </text>
</g>`.trim();
    }).join("");

    const slogFs = Math.round(size * 0.058);
    const slogY = Math.round(size * 0.93);
    const botTxt = safe(bottomTitle || "CHASE YOUR GOALS", 80);

    const bottomSvg = `
<text x="${Math.round(size * 0.5)}" y="${slogY}"
  fill="${accent}" font-size="${slogFs}" font-weight="900" letter-spacing="2"
  text-anchor="middle" dominant-baseline="middle"
  font-family="system-ui, -apple-system, Segoe UI, Roboto, Arial">
  ${escapeXml(botTxt)}
</text>`.trim();

    return `<g>${topTitleSvg}${rows}${bottomSvg}</g>`;
  }

  // -----------------------------
  // Map (OSM Overpass) routes-only, corridor around trace
  // -----------------------------
  function bboxFromPts(pts) {
    let minLat = Infinity, maxLat = -Infinity, minLon = Infinity, maxLon = -Infinity;
    for (const p of pts) {
      minLat = Math.min(minLat, p.lat); maxLat = Math.max(maxLat, p.lat);
      minLon = Math.min(minLon, p.lon); maxLon = Math.max(maxLon, p.lon);
    }
    return { minLat, minLon, maxLat, maxLon };
  }

  function expandBbox(b, factor = 0.10) {
    const dLat = (b.maxLat - b.minLat) || 1e-6;
    const dLon = (b.maxLon - b.minLon) || 1e-6;
    return {
      minLat: b.minLat - dLat * factor,
      maxLat: b.maxLat + dLat * factor,
      minLon: b.minLon - dLon * factor,
      maxLon: b.maxLon + dLon * factor,
    };
  }

  function projectLonLatToBox(lon, lat, bbox, box) {
    const lngRange = Math.max(1e-12, bbox.maxLon - bbox.minLon);
    const latRange = Math.max(1e-12, bbox.maxLat - bbox.minLat);
    const x = box.x0 + ((lon - bbox.minLon) / lngRange) * box.w;
    const y = box.y0 + ((bbox.maxLat - lat) / latRange) * box.h; // north up
    return { x, y };
  }

  function distPointSeg(px, py, ax, ay, bx, by) {
    const vx = bx - ax, vy = by - ay;
    const wx = px - ax, wy = py - ay;
    const c1 = vx * wx + vy * wy;
    if (c1 <= 0) return Math.hypot(px - ax, py - ay);
    const c2 = vx * vx + vy * vy;
    if (c2 <= c1) return Math.hypot(px - bx, py - by);
    const t = c1 / c2;
    const cx = ax + t * vx, cy = ay + t * vy;
    return Math.hypot(px - cx, py - cy);
  }

  function simplifyRDP(points, eps) {
    if (points.length <= 2) return points;
    let maxD = 0, idx = 0;
    const a = points[0], b = points[points.length - 1];
    for (let i = 1; i < points.length - 1; i++) {
      const p = points[i];
      const d = distPointSeg(p.x, p.y, a.x, a.y, b.x, b.y);
      if (d > maxD) { maxD = d; idx = i; }
    }
    if (maxD > eps) {
      const left = simplifyRDP(points.slice(0, idx + 1), eps);
      const right = simplifyRDP(points.slice(idx), eps);
      return left.slice(0, -1).concat(right);
    }
    return [a, b];
  }

  function approxPathLengthPx(pts) {
    let L = 0;
    for (let i = 1; i < pts.length; i++) {
      const dx = pts[i].x - pts[i - 1].x;
      const dy = pts[i].y - pts[i - 1].y;
      L += Math.hypot(dx, dy);
    }
    return L;
  }

  function keepRouteNearTrace(routeXY, traceXY, corridorPx) {
    // quick bbox reject
    let rMinX = Infinity, rMaxX = -Infinity, rMinY = Infinity, rMaxY = -Infinity;
    for (const p of routeXY) {
      rMinX = Math.min(rMinX, p.x); rMaxX = Math.max(rMaxX, p.x);
      rMinY = Math.min(rMinY, p.y); rMaxY = Math.max(rMaxY, p.y);
    }
    let tMinX = Infinity, tMaxX = -Infinity, tMinY = Infinity, tMaxY = -Infinity;
    for (const p of traceXY) {
      tMinX = Math.min(tMinX, p.x); tMaxX = Math.max(tMaxX, p.x);
      tMinY = Math.min(tMinY, p.y); tMaxY = Math.max(tMaxY, p.y);
    }
    if (rMaxX < tMinX - corridorPx || rMinX > tMaxX + corridorPx ||
      rMaxY < tMinY - corridorPx || rMinY > tMaxY + corridorPx) return false;

    // fine check: segment distance to sampled trace points
    const step = Math.max(1, Math.floor(traceXY.length / 140)); // <=140 points
    for (let i = 0; i < routeXY.length - 1; i++) {
      const a = routeXY[i], b = routeXY[i + 1];
      for (let j = 0; j < traceXY.length; j += step) {
        const p = traceXY[j];
        if (distPointSeg(p.x, p.y, a.x, a.y, b.x, b.y) <= corridorPx) return true;
      }
    }
    return false;
  }

  async function fetchOsmRoadsOverpass(bbox, timeoutMs = 12000) {
    const key = `${bbox.minLat.toFixed(5)},${bbox.minLon.toFixed(5)},${bbox.maxLat.toFixed(5)},${bbox.maxLon.toFixed(5)}`;
    if (mapCache.has(key)) return mapCache.get(key);

    // "All drivable roads" (avoid foot/cycle/path noise).
    // If you include footway/path/track/cycleway here, you will get lots of tiny segments.
    const highwayRegex =
      "motorway|motorway_link|trunk|trunk_link|primary|primary_link|secondary|secondary_link|tertiary|tertiary_link|residential|unclassified|service|living_street";

    const query = `
[out:json][timeout:15];
(
  way["highway"~"${highwayRegex}"](${bbox.minLat},${bbox.minLon},${bbox.maxLat},${bbox.maxLon});
);
(._;>;);
out body;
`.trim();

    const ctrl = new AbortController();
    const to = setTimeout(() => ctrl.abort(), timeoutMs);

    // IMPORTANT: loader is handled at the global render level (rebuildFromCurrent + overlay.onload)
    // Do not toggle loader here, otherwise it may stop before the SVG image is actually visible.
    const res = await fetch(OVERPASS_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
      body: "data=" + encodeURIComponent(query),
      signal: ctrl.signal
    }).finally(() => {
      clearTimeout(to);
    });


    if (!res.ok) throw new Error("Overpass: impossible de récupérer la carte (OSM).");
    const json = await res.json();

    const nodes = new Map();
    for (const el of json.elements) {
      if (el.type === "node") nodes.set(el.id, { lat: el.lat, lon: el.lon });
    }

    const ways = [];
    for (const el of json.elements) {
      if (el.type !== "way" || !el.nodes || el.nodes.length < 2) continue;
      const hw = el.tags && el.tags.highway;
      const coords = [];
      for (const nid of el.nodes) {
        const n = nodes.get(nid);
        if (n) coords.push({ lat: n.lat, lon: n.lon });
      }
      if (coords.length >= 2) ways.push({ highway: hw, coords });
    }

    mapCache.set(key, ways);
    return ways;
  }

  function strokeForHighway(hw, theme) {
    // DTF-safe: 2 greys max + normalize *_link
    const roadA = theme === "white" ? "#bdbdbd" : "#d0d0d0";
    const roadB = theme === "white" ? "#9f9f9f" : "#b8b8b8";
    const h = (hw || "").replace("_link", "");

    // Slightly thinner overall to avoid "mud" on dense 도시 areas
    if (!h) return { c: roadA, w: 7.5 };
    if (h === "motorway" || h === "trunk") return { c: roadB, w: 10.5 };
    if (h === "primary") return { c: roadA, w: 9.5 };
    if (h === "secondary") return { c: roadA, w: 8.5 };
    if (h === "tertiary") return { c: roadA, w: 7.5 };
    return { c: roadA, w: 6.5 };
  }

  async function buildMapRoutesSvgGroup({ pts, bboxRef, box, theme, corridorPx, epsPx, maxPaths }) {
    const bbox = bboxRef;

    const renderKey = [
      bbox.minLat.toFixed(5), bbox.minLon.toFixed(5), bbox.maxLat.toFixed(5), bbox.maxLon.toFixed(5),
      box.x0.toFixed(1), box.y0.toFixed(1), box.w.toFixed(1), box.h.toFixed(1),
      theme, corridorPx, epsPx, maxPaths
    ].join("|");

    if (mapGroupCache.has(renderKey)) return mapGroupCache.get(renderKey);

    const ways = await fetchOsmRoadsOverpass(bbox);

    // trace XY for corridor
    const traceXY = pts.map(p => projectLonLatToBox(p.lon, p.lat, bbox, box));

    // Collect ALL candidate roads inside corridor, then keep the longest ones.
    // This avoids the "miettes" effect caused by taking the first N ways returned by Overpass.
    const items = [];

    // Minimum visible length for a road segment (in pixels). Filters tiny fragments.
    const minLenPx = Math.max(60, box.w * 0.03);

    for (const w of ways) {
      const routeXY = w.coords.map(c => projectLonLatToBox(c.lon, c.lat, bbox, box));
      if (!keepRouteNearTrace(routeXY, traceXY, corridorPx)) continue;

      const simp = simplifyRDP(routeXY, epsPx);
      if (simp.length < 2) continue;

      const len = approxPathLengthPx(simp);
      if (len < minLenPx) continue;

      let d = `M${simp[0].x.toFixed(1)} ${simp[0].y.toFixed(1)}`;
      for (let i = 1; i < simp.length; i++) d += ` L${simp[i].x.toFixed(1)} ${simp[i].y.toFixed(1)}`;

      const st = strokeForHighway(w.highway, theme);
      items.push({ d, st, len });
    }

    if (!items.length) {
      mapGroupCache.set(renderKey, "");
      return "";
    }

    // Keep the longest roads first (best visual continuity)
    items.sort((a, b) => b.len - a.len);
    const top = items.slice(0, Math.max(0, maxPaths | 0));

    const paths = top.map(it =>
      `<path d="${it.d}" fill="none" stroke="${it.st.c}" stroke-width="${it.st.w}" stroke-linecap="round" stroke-linejoin="round"/>`
    );

    // (paths is guaranteed non-empty here)

    const clipId = "rxMapClip";
    const group = `
<g>
  <defs>
    <clipPath id="${clipId}">
      <rect x="${box.x0.toFixed(1)}" y="${box.y0.toFixed(1)}" width="${box.w.toFixed(1)}" height="${box.h.toFixed(1)}" rx="0" ry="0"/>
    </clipPath>
  </defs>
  <g clip-path="url(#${clipId})">
    ${paths.join("\n")}
  </g>
</g>`.trim();

    mapGroupCache.set(renderKey, group);
    return group;
  }

  // -----------------------------
  // SVG builders
  // -----------------------------
  function computeTraceBox(size, pad, traceScale, pts) {
    const reservedTop = Math.round(size * 0.18);
    const reservedBottom = Math.round(size * 0.18);
    const drawTop = pad + reservedTop;
    const drawBottom = size - pad - reservedBottom;
    const drawH = Math.max(10, drawBottom - drawTop);
    const drawW = size - 2 * pad;

    // bbox (lat/lon)
    let minLat = Infinity, maxLat = -Infinity, minLon = Infinity, maxLon = -Infinity;
    for (const p of pts) {
      minLat = Math.min(minLat, p.lat); maxLat = Math.max(maxLat, p.lat);
      minLon = Math.min(minLon, p.lon); maxLon = Math.max(maxLon, p.lon);
    }
    const bbox = { minLat, minLon, maxLat, maxLon };

    // expand a bit so roads have margin
    const bboxRef = expandBbox(bbox, 0.10);

    const latRange = Math.max(1e-12, bboxRef.maxLat - bboxRef.minLat);
    const lonRange = Math.max(1e-12, bboxRef.maxLon - bboxRef.minLon);

    const w = drawW / (traceScale || 1);
    const h = drawH / (traceScale || 1);
    const scale = Math.min(w / lonRange, h / latRange);

    const usedW = lonRange * scale;
    const usedH = latRange * scale;

    const offsetX = (size - usedW) / 2;
    const offsetY = drawTop + (drawH - usedH) / 2;

    const box = { x0: offsetX, y0: offsetY, w: usedW, h: usedH };

    return { bboxRef, box, drawTop, drawBottom };
  }

  async function buildTraceSvg(pts, opts, seqId) {
    const size = Number(opts.size) || 2400;
    const pad = Number(opts.pad) || 140;
    const sw = Number(opts.sw) || 28;

    const strokeColor = String(opts.strokeColor || "#ff5a00");
    const outlineOn = !!opts.outlineOn;
    const outlineColor = String(opts.outlineColor || "#ffffff");
    const outlineExtra = Number(opts.outlineExtra) || 18;

    const glowOn = !!opts.glowOn;
    const glowColor = String(opts.glowColor || strokeColor);
    const glowStrengthN = Number(opts.glowStrength ?? 0.7);

    const roundCaps = !!opts.roundCaps;
    const flipY =  true;
    const panelOn = !!opts.panelOn;

    const traceScaleN = Number(opts.traceScale ?? 1.0);

    // Compute box/bbox
    const { bboxRef, box } = computeTraceBox(size, pad, traceScaleN, pts);

    // Build trace path in SAME bboxRef/box (north up)
    let d = "";
    for (let i = 0; i < pts.length; i++) {
      const p = pts[i];

      // x linear
      const x = box.x0 + ((p.lon - bboxRef.minLon) / Math.max(1e-12, (bboxRef.maxLon - bboxRef.minLon))) * box.w;

      // y
      const yBase = box.y0 + ((bboxRef.maxLat - p.lat) / Math.max(1e-12, (bboxRef.maxLat - bboxRef.minLat))) * box.h;
      // flipY option: if unchecked, invert lat (not recommended); keep behavior similar
      const y = flipY ? yBase : (box.y0 + ((p.lat - bboxRef.minLat) / Math.max(1e-12, (bboxRef.maxLat - bboxRef.minLat))) * box.h);

      d += (i === 0 ? "M" : "L") + x.toFixed(2) + " " + y.toFixed(2) + " ";
    }

    const cap = roundCaps ? "round" : "butt";
    const join = roundCaps ? "round" : "miter";
    const defs = buildDefs({ glowOn, glowColor, glowStrength: glowStrengthN, sw });

    // MAP (vector routes)
    let mapGroup = "";
    const mapOn = !!opts.mapOn;
    if (mapOn) {
      const corridorPx = Math.max(60, Math.round(size * 0.10)); // ~5% canvas
      const epsPx = Math.max(2, Math.round(size * 0.002));      // ~0.2% canvas
      const maxPaths = 1500;

      // allow cancel if user moves sliders quickly
      const localSeq = seqId;

      try {
        mapGroup = await buildMapRoutesSvgGroup({
          pts,
          bboxRef,
          box,
          theme: opts.theme,
          corridorPx,
          epsPx,
          maxPaths
        });

        // if a newer rebuild started, ignore map
        if (localSeq !== buildSeq) mapGroup = "";
      } catch (e) {
        console.warn("Map error:", e);
        mapGroup = "";
      }
    }

    const outlinePath = outlineOn
      ? `<path d="${d.trim()}" fill="none" stroke="${outlineColor}" stroke-width="${sw + outlineExtra}" stroke-linecap="${cap}" stroke-linejoin="${join}"/>`
      : "";

    const mainPath = `<path d="${d.trim()}" fill="none" stroke="${strokeColor}" stroke-width="${sw}" stroke-linecap="${cap}" stroke-linejoin="${join}"/>`;

    const panel = buildPanel({
      size,
      panelOn,
      theme: opts.theme,
      topTitle: opts.topTitle,
      bottomTitle: opts.bottomTitle,
      metrics: opts.metrics,
      panelX: opts.panelX,
      panelY: opts.panelY,
      summaryScale: opts.summaryScale
    });

    const groupOpen = glowOn ? `<g filter="url(#glow)">` : `<g>`;

    return `
<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">
  ${defs}
  ${mapGroup}
  ${groupOpen}
    ${outlinePath}
    ${mainPath}
  </g>
  ${panel}
</svg>`.trim();
  }

  function buildElevationSvg(pts, opts) {
    const size = Number(opts.size) || 2400;
    const pad = Number(opts.pad) || 140;
    const sw = Number(opts.sw) || 28;

    const strokeColor = String(opts.strokeColor || "#ff5a00");
    const outlineOn = !!opts.outlineOn;
    const outlineColor = String(opts.outlineColor || "#ffffff");
    const outlineExtra = Number(opts.outlineExtra) || 18;

    const glowOn = !!opts.glowOn;
    const glowColor = String(opts.glowColor || strokeColor);
    const glowStrengthN = Number(opts.glowStrength ?? 0.7);

    const roundCaps = !!opts.roundCaps;
    const panelOn = !!opts.panelOn;

    if (!pts.some(p => p.ele != null)) throw new Error("Profil dénivelé impossible : ton GPX n'a pas de <ele>.");

    const reservedTop = Math.round(size * 0.18);
    const reservedBottom = Math.round(size * 0.18);
    const drawTop = pad + reservedTop;
    const drawBottom = size - pad - reservedBottom;
    const innerH = Math.max(10, drawBottom - drawTop);
    const innerW = size - 2 * pad;

    const de = buildDistanceElevation(pts);
    const xs = de.distKm;
    const ys = de.eleM;

    const points = [];
    for (let i = 0; i < xs.length; i++) {
      if (ys[i] == null) continue;
      points.push({ x: xs[i], y: ys[i] });
    }
    if (points.length < 2) throw new Error("Profil dénivelé : pas assez de points avec <ele>.");

    let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
    for (const p of points) {
      minX = Math.min(minX, p.x); maxX = Math.max(maxX, p.x);
      minY = Math.min(minY, p.y); maxY = Math.max(maxY, p.y);
    }
    const xRange = Math.max(1e-12, maxX - minX);
    const yRange = Math.max(1e-12, maxY - minY);

    const xScale = innerW / xRange;
    const yScale = innerH / yRange;

    const x0 = pad;
    const y0 = drawTop;

    let d = "";
    for (let i = 0; i < points.length; i++) {
      const p = points[i];
      const x = x0 + (p.x - minX) * xScale;
      const y = y0 + (maxY - p.y) * yScale;
      d += (i === 0 ? "M" : "L") + x.toFixed(2) + " " + y.toFixed(2) + " ";
    }

    const cap = roundCaps ? "round" : "butt";
    const join = roundCaps ? "round" : "miter";

    const defs = buildDefs({ glowOn, glowColor, glowStrength: glowStrengthN, sw });

    const outlinePath = outlineOn
      ? `<path d="${d.trim()}" fill="none" stroke="${outlineColor}" stroke-width="${sw + outlineExtra}" stroke-linecap="${cap}" stroke-linejoin="${join}"/>`
      : "";
    const mainPath = `<path d="${d.trim()}" fill="none" stroke="${strokeColor}" stroke-width="${sw}" stroke-linecap="${cap}" stroke-linejoin="${join}"/>`;

    const panel = buildPanel({
      size,
      panelOn,
      theme: opts.theme,
      topTitle: opts.topTitle,
      bottomTitle: opts.bottomTitle,
      metrics: opts.metrics,
      panelX: opts.panelX,
      panelY: opts.panelY,
      summaryScale: opts.summaryScale
    });

    const groupOpen = glowOn ? `<g filter="url(#glow)">` : `<g>`;

    return `
<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">
  ${defs}
  ${groupOpen}
    ${outlinePath}
    ${mainPath}
  </g>
  ${panel}
</svg>`.trim();
  }

  // -----------------------------
  // Overlay rendering & download
  // -----------------------------
  function setOverlaySvg(svgString) {
  if (!overlay) return;

  if (lastObjectUrl) URL.revokeObjectURL(lastObjectUrl);

  const blob = new Blob([svgString], {
    type: "image/svg+xml;charset=utf-8"
  });

  const url = URL.createObjectURL(blob);
  lastObjectUrl = url;

  overlay.style.display = "none";

  // ⚠️ IMPORTANT : handlers AVANT src
  overlay.onload = () => {
    overlay.style.display = "block";
    setMapBusy(false); // ✅ stop loader ICI
  };

  overlay.onerror = () => {
    overlay.style.display = "none";
    setMapBusy(false); // sécurité
    setStatus("Erreur: SVG non rendu.", true);
  };

  overlay.src = url; // seulement maintenant
}


  function downloadText(filename, text) {
    const blob = new Blob([text], { type: "image/svg+xml;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }

  // -----------------------------
  // UI state
  // -----------------------------
  function syncUi() {
    if (strokeWidthVal && strokeWidth) strokeWidthVal.textContent = strokeWidth.value;
    if (outlineWidthVal && outlineWidth) outlineWidthVal.textContent = outlineWidth.value;
    if (glowVal && glowStrength) glowVal.textContent = Number(glowStrength.value).toFixed(2);
    if (traceScaleVal && traceScale) traceScaleVal.textContent = Number(traceScale.value).toFixed(2);
    if (summaryScaleVal && summaryScale) summaryScaleVal.textContent = Number(summaryScale.value).toFixed(2);

    const outlineOn = $("rxOutlineOn")?.checked;
    if ($("rxOutlineColor")) $("rxOutlineColor").disabled = !outlineOn;
    if (outlineWidth) outlineWidth.disabled = !outlineOn;

    const glowOn = $("rxGlowOn")?.checked;
    if ($("rxGlowColor")) $("rxGlowColor").disabled = !glowOn;
    if (glowStrength) glowStrength.disabled = !glowOn;

    const dl = $("rxDownload");
    if (dl) dl.disabled = !lastSvg;
  }

  function readState() {
    return {
      size: $("rxSize")?.value,
      pad: $("rxPad")?.value || 140,
      sw: $("rxStrokeWidth")?.value,
      strokeColor: $("rxStrokeColor")?.value,
      traceScale: Number($("rxTraceScale")?.value || 1),
      outlineOn: $("rxOutlineOn")?.checked,
      outlineColor: $("rxOutlineColor")?.value,
      outlineExtra: $("rxOutlineWidth")?.value,
      glowOn: $("rxGlowOn")?.checked,
      glowColor: $("rxGlowColor")?.value,
      glowStrength: $("rxGlowStrength")?.value,
      roundCaps: $("rxRoundCaps")?.checked,
      panelOn: $("rxPanelOn")?.checked,
      theme: $("rxTheme")?.value || "orange",
      topTitle: $("rxTopTitle")?.value,
      bottomTitle: $("rxBottomTitle")?.value,
      metrics: getMetrics(),
      panelX: Number($("rxPanelX")?.value || 0.65),
      panelY: Number($("rxPanelY")?.value || 0.50),
      summaryScale: Number($("rxSummaryScale")?.value || 1.08),

      // map
      mapOn: mapOnEl ? mapOnEl.checked : false,
      mapStyle: "topo_light"
    };
  }

  // Debounce (avoid spamming Overpass)
  let rebuildTimer = null;
  function requestRebuild() {
    if (rebuildTimer) clearTimeout(rebuildTimer);
    rebuildTimer = setTimeout(() => rebuildFromCurrent(), 120);
  }

 async function rebuildFromCurrent() {
  if (!lastPts || !lastPts.length) return;

  const seqId = ++buildSeq;
  const st = readState();
  const mode = getMode();

  // Loader: ON seulement si on est en TRACE + fond carte activé
  const waitForMap = (mode === "trace" && !!st.mapOn);
  if (waitForMap) setMapBusy(true);
  else setMapBusy(false);

  try {
    setStatus(mode === "trace" ? "Rendu… (tracé)" : "Rendu… (dénivelé)");
    syncUi();

    let svg = "";
    if (mode === "elev") {
      svg = buildElevationSvg(lastPts, st);
      if (seqId !== buildSeq) return;

      lastSvg = svg;
      setOverlaySvg(svg); // en elev, le loader est déjà OFF
    } else {
      // trace: buildTraceSvg est async (fetch Overpass etc.)
      svg = await buildTraceSvg(lastPts, st, seqId);
      if (seqId !== buildSeq) return;

      lastSvg = svg;
      setOverlaySvg(svg); // IMPORTANT: setOverlaySvg() stoppe le loader via overlay.onload
    }

    const dl = $("rxDownload");
    if (dl) dl.disabled = false;

    setStatus(`Rendu mis à jour ✅ (${mode === "elev" ? "Profil dénivelé" : "Tracé GPS"})`);
  } catch (e) {
    setStatus(e?.message || String(e), true);
    setMapBusy(false); // sécurité: ne jamais laisser le loader tourner
  }

  syncUi();
}

  // -----------------------------
  // Init + Events
  // -----------------------------
  async function loadExampleOnInit() {
    try {
      setStatus("Chargement de l’exemple…");
      const r = await fetch(EXAMPLE_GPX_URL, { cache: "force-cache" });
      if (!r.ok) throw new Error("Impossible de charger le GPX exemple.");
      const text = await r.text();
      lastPts = parseGpx(text);

      const stats = computeStats(lastPts, 1.0);
      autofillMetrics(stats);

      await rebuildFromCurrent();
      setStatus("");
    } catch (e) {
      setStatus(e?.message || String(e), true);
    }
  }

  // Monte le toggle "Options avancées" avant de binder les events
  mountAdvancedToggle();

  // WATCH list (includes map controls if present)
const WATCH = [
  "rxModeTrace", "rxModeElev",
  "rxSize", "rxPad", "rxStrokeWidth",
  "rxStrokeColor", "rxTraceScale",
  "rxOutlineOn", "rxOutlineColor", "rxOutlineWidth",
  "rxGlowOn", "rxGlowColor", "rxGlowStrength",
  "rxRoundCaps", "rxPanelOn", "rxTheme",
  "rxPanelX", "rxPanelY", "rxSummaryScale",
  "rxTopTitle", "rxBottomTitle",
  "rxM1On", "rxM1Icon", "rxM1Val", "rxM1Lab",
  "rxM2On", "rxM2Icon", "rxM2Val", "rxM2Lab",
  "rxM3On", "rxM3Icon", "rxM3Val", "rxM3Lab",
  "rxM4On", "rxM4Icon", "rxM4Val", "rxM4Lab",
  "rxMapOn"
];


  WATCH.forEach(id => {
    const el = $(id);
    if (!el) return;
    el.addEventListener("input", requestRebuild);
    el.addEventListener("change", requestRebuild);
  });

  // Mode UI (3 boutons)
  document.querySelectorAll('input[name="rxModeUI"]').forEach((r) => {
    r.addEventListener('change', (e) => setModeFromUI(e.target.value));
  });

  // Au chargement: synchronise l'UI avec l'état legacy (si présent)
  // (évite un état incohérent si Shopify cache/restore des inputs)
  try {
    const legacyMode = getMode();
    const mapChecked = !!$("rxMapOn")?.checked;
    const wanted = legacyMode === 'elev' ? 'elev' : (mapChecked ? 'trace_map' : 'trace_plain');
    const ui = document.querySelector(`input[name="rxModeUI"][value="${wanted}"]`);
    if (ui) ui.checked = true;
  } catch (e) {}

  // color coupling
  $("rxStrokeColor")?.addEventListener("input", () => {
    if (!glowManuallyChanged && $("rxGlowColor")) $("rxGlowColor").value = $("rxStrokeColor").value;
  });
  $("rxGlowColor")?.addEventListener("input", () => { glowManuallyChanged = true; });

  // Import
  $("rxImport")?.addEventListener("click", async () => {
    try {
      const f = $("rxGpxFile")?.files && $("rxGpxFile").files[0];
      if (!f) return setStatus("Choisis un fichier .gpx puis clique Importer.", true);

      const text = await f.text();
      lastPts = parseGpx(text);

      const stats = computeStats(lastPts, 1.0);
      autofillMetrics(stats);

      await rebuildFromCurrent();
      setStatus("Ton GPX a remplacé l’exemple ✅");
    } catch (e) {
      lastPts = null;
      lastSvg = "";
      if (overlay) overlay.style.display = "none";
      $("rxDownload") && ($("rxDownload").disabled = true);
      setStatus(e?.message || String(e), true);
    }
    syncUi();
  });

  // Download
  $("rxDownload")?.addEventListener("click", () => {
    if (!lastSvg) return;
    const mode = getMode();
    downloadText(mode === "elev" ? "run-summary-elevation.svg" : "run-summary-trace.svg", lastSvg);
    setStatus("Téléchargement lancé ✅");
  });

  // Go
  syncUi();
  loadExampleOnInit();
})();

